import React from "react";
import {
  ManagerIconSettingSvg,
  ChartSvg,
  ChartIcon,
  DashboardIcon,
  LogoutIcon,
  IndexIcon,
  OprationIcon,
  ReportIcon,
  SettingIcon,
  DeleteBoxInAdminDashboardSetting,
  DataIcon,
  NikoHeartBg,
  NikoPeopleBg,
  NikoReportBg,
  NikoCommentBg,
  WaitingCommentBg,
  TriangleSign,
  BgHeartNiko,
  ThreeDCubeIconNiko,
  NikoTimeBg,
  NikoMoneyBg,
  GalleryIconNiko,
  DashboardIconNiko,
  GroupIconNiko,
  LocationIconNiko,
  BlogIconNiko,
  MessageTextNiko,
  MessageTextBubbleNiko,
  MoneysNiko,
  NoteIconNiko,
  Profile2usersNiko,
  SettingNiko,
  NikoGolestanIcon,
  EnvelopeIconAutoC,
  NotificationBellIconAutoC,
  PersonIconAutoC,
  LogoAutoC,
  DashboardIconAutoC,
  PaymentAutoCIcon,
  SupportAutoCIcon,
  BusAutoCIcon,
  SettingAutoCIcon,
  TaxiAutoCIcon,
  BusCardSvg,
  CoinCardSvgBus,
  CustomServiceCardBus,
  MoneyCardSvgBus,
  MessageCardSvgBus,
  BusStopCardSvgBus,
  NumberOfTaxiesBus,
  RavanhesabOmurMaliMenuIcon,
  RavanhesabHazinehaMenuIcon,
  RavanhesabBankMenuIcon,
  RavanhesabPeopleMenuIcon,
  RavanhesabKalaMenuIcon,
  RavanhesabAnbarMenuIcon,
  RavanhesabSarmayeMenuIcon,
  RavanhesabCalculatorMenuIcon,
  RavanhesabBilanSarmayeMenuIcon,
  RavanhesabFishMenuIcon,
  RavanhesabLogo,
  LocSvg,
  PersonsSvg,
  AboutUsSvg,
  Toka,
  ScrumIcon,
  ProgrammersIcon,
  DocumentationIcon, VersionIcon, BalanceSheetIcon, ReportsIcon, BlueRavanhesabLogo, ArkaLogo, MonitorIcon,
} from "./index";

function AboutSvg() {
  return null;
}

const IconViewer = (props) => {
  const {icon} = props;

  // if (icon === "DashboardIconNiko") {
  //   //debugger
  // }
  if (icon === undefined) {
    //debugger
    console.log(
      "%cbackend Must give me Icon To show",
      "color: #f709bb; font-family: sans-serif; font-size:20px;"
    );
    return <></>;
  }
  // return <></>
  return (
    <>
      {icon === "RavanhesabSarmayeMenuIcon" && <RavanhesabSarmayeMenuIcon/>}
      {icon === "RavanhesabAnbarMenuIcon" && <RavanhesabAnbarMenuIcon/>}
      {icon === "RavanhesabKalaMenuIcon" && <RavanhesabKalaMenuIcon/>}
      {icon === "RavanhesabPeopleMenuIcon" && <RavanhesabPeopleMenuIcon/>}
      {icon === "RavanhesabBankMenuIcon" && <RavanhesabBankMenuIcon/>}
      {icon === "RavanhesabHazinehaMenuIcon" && <RavanhesabHazinehaMenuIcon/>}
      {icon === "ManagerIconSettingSvg" && <ManagerIconSettingSvg/>}
      {icon === "ChartSvg" && <ChartSvg/>}
      {icon === "ChartIcon" && <ChartIcon/>}
      {icon === "LogoutIcon" && <LogoutIcon/>}
      {icon === "DashboardIcon" && <DashboardIcon/>}
      {icon === "OprationIcon" && <OprationIcon/>}
      {icon === "ReportIcon" && <ReportIcon/>}
      {icon === "SettingIcon" && <SettingIcon/>}
      {icon === "DeleteBoxInAdminDashboardSetting" && (
        <DeleteBoxInAdminDashboardSetting/>
      )}
      {icon === "DataIcon" && <DataIcon/>}
      {icon === "NikoTimeBg" && <NikoTimeBg/>}
      {icon === "NikoMoneyBg" && <NikoMoneyBg/>}
      {icon === "NikoHeartBg" && <NikoHeartBg/>}
      {icon === "NikoPeopleBg" && <NikoPeopleBg/>}
      {icon === "NikoReportBg" && <NikoReportBg/>}
      {icon === "NikoCommentBg" && <NikoCommentBg/>}
      {icon === "WaitingCommentBg" && <WaitingCommentBg/>}
      {icon === "IndexIcon" && <IndexIcon/>}
      {icon === "TriangleSign" && <TriangleSign/>}
      {icon === "BgHeartNiko" && <BgHeartNiko/>}

      {icon === "DashboardIconNiko" && <DashboardIconNiko/>}
      {icon === "GalleryIconNiko" && <GalleryIconNiko/>}
      {icon === "GroupIconNiko" && <GroupIconNiko/>}
      {icon === "LocationIconNiko" && <LocationIconNiko/>}
      {icon === "BlogIconNiko" && <BlogIconNiko/>}
      {icon === "MessageTextNiko" && <MessageTextNiko/>}
      {icon === "MessageTextBubbleNiko" && <MessageTextBubbleNiko/>}
      {icon === "MoneysNiko" && <MoneysNiko/>}
      {icon === "NoteIconNiko" && <NoteIconNiko/>}
      {icon === "Profile2usersNiko" && <Profile2usersNiko/>}
      {icon === "SettingNiko" && <SettingNiko/>}
      {icon === "ThreeDCubeIconNiko" && <ThreeDCubeIconNiko/>}
      {icon === "NikoGolestanIcon" && <NikoGolestanIcon/>}
      {icon === "EnvelopeIconAutoC" && <EnvelopeIconAutoC/>}
      {icon === "NotificationBellIconAutoC" && <NotificationBellIconAutoC/>}
      {icon === "PersonIconAutoC" && <PersonIconAutoC/>}
      {icon === "LogoAutoC" && <LogoAutoC/>}
      {icon === "DashboardIconAutoC" && <DashboardIconAutoC/>}
      {icon === "PaymentAutoCIcon" && <PaymentAutoCIcon/>}
      {icon === "SupportAutoCIcon" && <SupportAutoCIcon/>}
      {icon === "BusAutoCIcon" && <BusAutoCIcon/>}
      {icon === "SettingAutoCIcon" && <SettingAutoCIcon/>}
      {icon === "TaxiAutoCIcon" && <TaxiAutoCIcon/>}
      {icon === "NumberOfTaxiesBus" && <NumberOfTaxiesBus/>}

      {icon === "CoinCardSvgBus" && <CoinCardSvgBus/>}
      {icon === "CustomServiceCardBus" && <CustomServiceCardBus/>}
      {icon === "MoneyCardSvgBus" && <MoneyCardSvgBus/>}
      {icon === "MessageCardSvgBus" && <MessageCardSvgBus/>}
      {icon === "BusStopCardSvgBus" && <BusStopCardSvgBus/>}
      {icon === "BusCardSvg" && <BusCardSvg/>}
      {icon === "RavanhesabOmurMaliMenuIcon" && <RavanhesabOmurMaliMenuIcon/>}
      {icon === "RavanhesabCalculatorMenuIcon" && (
        <RavanhesabCalculatorMenuIcon/>
      )}
      {icon === "RavanhesabBilanSarmayeMenuIcon" && (
        <RavanhesabBilanSarmayeMenuIcon/>
      )}
      {icon === "RavanhesabFishMenuIcon" && <RavanhesabFishMenuIcon/>}
      {icon === "ravanhesabLogo" && <RavanhesabLogo/>}
      {icon === "BlueRavanhesabLogo" && <BlueRavanhesabLogo/>}
      {icon === "arkaLogo" && <ArkaLogo/>}
      {icon === "Toka" && <Toka/>}
      {icon === "PersonsSvg" && <PersonsSvg/>}
      {icon === "LocSvg" && <LocSvg/>}
      {icon === "AboutUsSvg" && <AboutUsSvg/>}
      {icon === "ScrumIcon" && <ScrumIcon/>}
      {icon === "ProgrammersIcon" && <ProgrammersIcon/>}
      {icon === "DocumentationIcon" && <DocumentationIcon/>}
      {icon === "VersionIcon" && <VersionIcon/>}
      {icon === "BalanceSheetIcon" && <BalanceSheetIcon/>}
      {icon === "ReportsIcon" && <ReportsIcon/>}
      {icon === "MonitorIcon" && <MonitorIcon/>}
    </>
  );
};

export default IconViewer;
